export const tableStyle = {
    backgroundColor: 'white',
    borderCollapse: 'collapse',
    color: '#181818',
    headerStyle: {
        backgroundColor: '#006ad1',
        width: '1000px',
        fontFamily: 'Roboto-Medium',
    },
    headerCellStyle: {
        display: 'flex',
        alignItems: 'center',
        height: '40px',
        color: 'white',
        fontSize: '0.90rem',
        width: 'auto',
    },
    rightBorder: {
        borderRight: '1.5px solid lightgrey'
    },
    rowStyle: {
        borderBottom: '1px solid lightgrey',
        borderTop: '1px solid lightgrey',

    },
    rowCellStyle: {
        height: '24.25px',
        fontSize: '14px',
        margin: '10px 10px',
        padding: '0.65vh 0.125vw',
        minWidth: '80px',
        maxWidth: '120px',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
    },
    evenRow: {
        backgroundColor: '#d5e5ff',
    },
    oddRow: {
        backgroundColor: '#f2f4f6',
    },
}

export const tableStyleOverDue = {
    backgroundColor: 'white',
    borderCollapse: 'collapse',
    color: '#181818',
    headerStyle: {
        backgroundColor: '#9d192f',
        width: '1000px',
        fontFamily: 'Roboto-Medium',
    },
    headerCellStyle: {
        display: 'flex',
        alignItems: 'center',
        color: 'white',
        height: '40px',
        fontSize: '0.90rem',
        width: 'auto',
    },
    rowStyle: {
        borderBottom: '1px solid lightgrey',
        borderTop: '1px solid lightgrey',
    },
    rowCellStyle: {
        height: '24.25px',
        fontSize: '14px',
        margin: '10px 10px',
        padding: '0.65vh 0.125vw',
        width: 'auto',
        minWidth: '80px',
        maxWidth: '120px',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
    },
    evenRow: {
        backgroundColor: '#fcebeb',
    },
    oddRow: {
        backgroundColor: '#f2f4f6',
    },
}

export const buttonStyle = { backgroundColor: 'white', border: '1px solid #006ad1', display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-evenly', borderRadius: '3px', marginRight: '5px', cursor: 'pointer', color: '#006ad1' }

export const internalIconStyles = { margin: '5px 10px 5px 5px', height: '18.5px' };

export const tableStyleLight = {
    backgroundColor: 'white',
    // borderCollapse: 'collapse',
    color: '#181818',
    headerStyle: {
        backgroundColor: '#ecedef',
        width: '1000px',
        fontFamily: 'Roboto-Medium',
    },
    headerCellStyle: {
        display: 'flex',
        alignItems: 'center',
        height: '30px',
        color: 'grey',
        fontSize: '0.90rem',
        width: 'auto',
    },
    rightBorder: {
        borderRight: '1.5px solid lightgrey'
    },
    rowStyle: {
        borderBottom: '1px solid lightgrey',
        borderTop: '1px solid lightgrey',

    },
    rowCellStyle: {
        height: '19px',
        fontSize: '14px',
        margin: '10px 10px',
        padding: '0.65vh 0.125vw',
        minWidth: '80px',
        maxWidth: '120px',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
    },
    evenRow: {
        backgroundColor: 'white',
    },
    oddRow: {
        backgroundColor: 'white',
    },
}